import { useCallback } from "react";
import { useSelector } from "react-redux";
import { dispatch } from "../../state/store";
import { resetDeviceKitList } from "../../state/ducks";

import { strCode } from "../../consts";
import { fleetManagementService, notificationService, t } from "../../services";

export const useFetchDeviceKitList = () => {
  const deviceKitList = useSelector((store) => store.fleetManagement?.deviceKitList);

  const fetchCallback = useCallback(
    async (isRefresh) => {
      if ((deviceKitList !== null && !isRefresh)) {
        return;
      }

      try {
        dispatch(resetDeviceKitList());

        await fleetManagementService.fetchDeviceKitList();
      } catch (err) {
        notificationService.showError({
          title: t(strCode.FETCH_DEVICE_KIT_LIST_ERROR),
          message: err?.response?.data?.error ? err?.response?.data?.error : err?.toString()
        });
      }
    },
    [deviceKitList]
  );

  return { fetchCallback, data: deviceKitList };
};
